import { useEffect, useState } from 'react';
import { AppDialog } from '../../../components/AppDialog';
import './quotes.css';

/**
 * Validate — legacy `QuoteValidation_DetailView` (700 × 250): Status Won | Lost,
 * and a Lost Reason that shows only for Lost. The host does the work and decides
 * whether the dialog closes; a refused answer (no reason, a clashing client
 * name) keeps it open, as legacy does.
 */
export function QuoteValidateDialog({
  open, busy, onAccept, onClose,
}: {
  open: boolean;
  busy: boolean;
  onAccept: (won: boolean, lostReason: string | null) => void;
  onClose: () => void;
}) {
  const [won, setWon] = useState(true);
  const [reason, setReason] = useState('');

  useEffect(() => {
    if (open) { setWon(true); setReason(''); }
  }, [open]);

  return (
    <AppDialog
      open={open}
      title="Quote Validation"
      width={560}
      onClose={onClose}
      footer={
        <>
          <button type="button" className="ca-btn ca-btn-solid" disabled={busy}
                  onClick={() => onAccept(won, won ? null : reason.trim() || null)}>
            OK
          </button>
          <button type="button" className="ca-btn" onClick={onClose}>Cancel</button>
        </>
      }
    >
      <div className="sd-grid sd-grid--single sd-grid--side qt-validate">
        <div className="sd-row">
          <span className="sd-label">Status<span className="req">*</span></span>
          <div className="qt-radios" role="radiogroup" aria-label="Status">
            <label className="sd-check">
              <input type="radio" name="qt-validate" checked={won} onChange={() => setWon(true)} /> Won
            </label>
            <label className="sd-check">
              <input type="radio" name="qt-validate" checked={!won} onChange={() => setWon(false)} /> Lost
            </label>
          </div>
        </div>
        {!won && (
          <div className="sd-row">
            <label className="sd-label" htmlFor="qt-lost-reason">Lost Reason<span className="req">*</span></label>
            <textarea id="qt-lost-reason" rows={3} maxLength={3000}
                      className={`sd-input sd-input--tall${reason.trim() ? '' : ' required-empty'}`}
                      value={reason} onChange={(e) => setReason(e.target.value)} />
          </div>
        )}
      </div>
    </AppDialog>
  );
}
